<template>
	<ConfigGenerator
		:template="template"
		/>
</template>

<script>
	import ConfigGenerator from '../../components/ConfigGenerator';

	export default {
		components : {ConfigGenerator},
		props : ['template'],
	}

</script>